import { crud } from '@think-internet/zeus-frontend-package'

const props = {
  ...crud.Features,

  // generic features
}

export default props
